// extracted by mini-css-extract-plugin
module.exports = {"hidden":"title_hidden__AtRCJ","textEmphasis":"title_textEmphasis__wXADk","titleArea":"title_titleArea__vHTb8","title":"title_title__WdFXm","date":"title_date__SbYvB"};